<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1238 5.91603L9.64271 15.6377L3.99805 10.5575L5.00149 9.44254L9.35683 13.3623L14.8757 5.08398L16.1238 5.91603Z"
    />
  </svg>
</template>
<script setup lang="ts"></script>
